<div class="customer-list">
  <!-- Search Bar -->
  <mat-form-field class="search-field">
    <mat-label>Search Customers</mat-label>
    <input matInput
           [(ngModel)]="searchTerm"
           [matAutocomplete]="auto"
           placeholder="Search Customers"
           (ngModelChange)="searchCustomers()"
           [value]="selectedCustomer?.name || searchTerm">

    <!-- Clear Button -->
    <button *ngIf="selectedCustomer || searchTerm" mat-icon-button matSuffix (click)="clearSelection()" aria-label="Clear">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>

  <!-- Autocomplete List -->
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCustomer($event.option.value)">
    <mat-option *ngFor="let customer of filteredCustomers" [value]="customer.name">
      {{ customer.name }}
    </mat-option>
  </mat-autocomplete>
</div>
